import React from "react";
import LotOfBoards from "./LotofBoard";
import { IBoardMenu } from "app/types";

interface LotOfBoardsButtonProps {
  hiddenBoards: IBoardMenu[];
}

const LotOfBoardsButton: React.FC<LotOfBoardsButtonProps> = ({
  hiddenBoards,
}) => {
  return (
    <React.Fragment>
      {hiddenBoards?.length > 0 && (
        <LotOfBoards
          options={hiddenBoards}
          trigger={
            <button className="relative flex flex-row items-center gap-2 px-4 uppercase text-sm font-normal text-secondary leading-5 py-2 hover:bg-gray-100 group flex-shrink-0 whitespace-nowrap bg-white">
              <span className="text-sm font-normal text-secondary">
                {hiddenBoards?.length} more
              </span>
            </button>
          }
        />
      )}
    </React.Fragment>
  );
};

export default LotOfBoardsButton;
